var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFd2Img6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0839844 14.0833C0.0839844 6.30532 6.38931 0 14.1673 0C21.9453 0 28.2507 6.30532 28.2507 14.0833C28.2507 21.8613 21.9453 28.1667 14.1673 28.1667C6.38931 28.1667 0.0839844 21.8613 0.0839844 14.0833Z",
    fill: "#C49A6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1921 9.97711V15.3889C15.5836 15.615 15.8896 15.9639 16.0626 16.3816C16.2356 16.7993 16.266 17.2624 16.149 17.6991C16.032 18.1359 15.7741 18.5218 15.4154 18.797C15.0567 19.0722 14.6173 19.2214 14.1651 19.2214C13.713 19.2214 13.2736 19.0722 12.9149 18.797C12.5562 18.5218 12.2983 18.1359 12.1813 17.6991C12.0643 17.2624 12.0946 16.7993 12.2677 16.3816C12.4407 15.9639 12.7467 15.615 13.1382 15.3889V9.97711C13.1382 9.70475 13.2464 9.44355 13.439 9.25097C13.6316 9.05839 13.8928 8.9502 14.1651 8.9502C14.4375 8.9502 14.6987 9.05839 14.8913 9.25097C15.0839 9.44355 15.1921 9.70475 15.1921 9.97711Z",
    stroke: "#FAF3EC",
    strokeWidth: 1.02691,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFd2Img6);
export default __webpack_public_path__ + "static/media/FD2img6.c0a30d3325299fdbb0df294baf25a62c.svg";
export { ForwardRef as ReactComponent };